import axios from 'axios'

export const AdminVersionService = {
  /**
   * Login to ICC Code Adoption admin with user provided credentials
   * @param data | user form data
   */
  fetchFeVersion () {
    return axios({
      method: 'get',
      url: 'VERSION',
      baseURL: '/',
      headers: {
        'Accept': 'text/plain'
      }
    })
  },
  fetchBeVersion () {
    return axios.get(`/public/api/v1/getVersion`)
  }
}
